
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fgD68", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getThemeOverrideFromQueryParameters", () => $4a4fa588159b3e38$export$169aec46c88e9cc8);
$parcel$export(module.exports, "default", () => $4a4fa588159b3e38$export$2e2bcd8739ae039);

var $1athg = parcelRequire("1athg");
var $hKOdA = parcelRequire("hKOdA");

var $hzgTF = parcelRequire("hzgTF");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");

var $6XJko = parcelRequire("6XJko");

var $fWIQB = parcelRequire("fWIQB");

var $135mT = parcelRequire("135mT");
const $4a4fa588159b3e38$export$169aec46c88e9cc8 = ({ query: query })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (query?.themeMode && (0, $hzgTF.ThemeOptions).includes(query.themeMode)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return query.themeMode;
    return undefined;
};
const $4a4fa588159b3e38$var$getResourceReturns = async (theme)=>{
    let typographyTheme;
    if ((0, $6XJko.isVisualRefreshEnabled)()) {
        typographyTheme = 'typography-modernized';
        if ((0, $7jTnu.fg)('platform-dst-jira-web-fonts') || (0, $7jTnu.fg)('platform-dst-jira-web-fonts-v3')) typographyTheme = 'typography-refreshed';
    }
    const attrs = (0, $1athg.default)({
        colorMode: theme,
        typography: typographyTheme
    });
    const styles = await (0, $hKOdA.default)({
        colorMode: theme,
        typography: typographyTheme
    });
    (0, $135mT.loadThemeTokens)(theme);
    return {
        theme: theme,
        attrs: attrs,
        styles: styles
    };
};
async function $4a4fa588159b3e38$export$2e2bcd8739ae039(context) {
    try {
        const theme = $4a4fa588159b3e38$export$169aec46c88e9cc8(context) || await (0, $fWIQB.getThemePreference)();
        return await $4a4fa588159b3e38$var$getResourceReturns(theme || (0, $hzgTF.DEFAULT_THEME));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.themePreferenceResource', 'themePreferenceResource', err);
        return {};
    }
}

});
parcelRegister("135mT", function(module, exports) {

$parcel$export(module.exports, "loadThemeTokens", () => $402723405f6ab7dd$export$de79e1eb6941ecb0);

var $7y92E = parcelRequire("7y92E");
const $402723405f6ab7dd$export$de79e1eb6941ecb0 = async (theme)=>{
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if ([
        'light',
        'dark',
        'auto'
    ].includes(theme)) await (0, $7y92E.default)({
        colorMode: theme
    });
};

});



//# sourceMappingURL=async-router-resources-theme-preference.eade092f.js.map
